import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class GroupAttrService {
  constructor(private http: HttpClient) {}

  public names(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/attribute-names`;
    return this.http.get(url, { params });
  }

  public preview(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/attributes`;
    return this.http.put(url, params).pipe(
      map((data: any) => {
        if (!data.attributes) {
          data.attributes = [];
        }
        for (const attr of data.attributes) {
          attr.firstSeenAt = Date.parse(attr.firstSeenAt);
          attr.lastSeenAt = Date.parse(attr.lastSeenAt);
        }
        return data;
      }),
    );
  }

  public create(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/attributes`;
    return this.http.post(url, params);
  }

  public delete(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/attributes`;
    return this.http.delete(url, { params });
  }

  public attrs(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/attributes`;
    return this.http.get(url, { params });
  }
}
